import React, { useRef, useState, useEffect } from "react";
import { Row, Image, Flex, Skeleton, Button } from "antd";
import { RightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import ic_addcollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_addcollection_contentlibrary.svg";
import ic_removecollection_contentlibrary from "../../../../../../../../assets/images/svgs/ic_removecollection_contentlibrary.svg";
import {
  colorTextDesc,
  colorTextTitleMobile,
  ColorPrimary,
  whiteColor,
} from "../../../../../../../../config/constant/color/index";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import defaultImage from "../../../../../../../../assets/images/png/general/img_thumb_default.png";

const CourseDescriptionContentLibraryMobile = ({
  loading,
  wraperStyle,
  rowImageStyle,
  index,
  thumbnail,
  divRightStyle,
  pProgramStyle,
  titleCourseDescStyle,
  courseName,
  rowBottomFirstStyle,
  rowBottomSecondStyle,
  pointImageWidth,
  totalPoint,
  totalCourses,
  dividerStyle,
  description,
  overDue,
  flagBtnCollection,
  funcCollection,
  isCollection,
  setOpenModalDetailCourse,
  isMobileVersion,
  mainState,
  location,
  isCollectionLoading = false,
}) => {
  const { t, i18n } = useTranslation();

  const textRef = useRef(null);
  const [isClamped, setIsClamped] = useState(false);
  const [pageBack, setPageBack] = useState(null);
  const navigate = useNavigate();
  // const locationHere = useLocation();

  useEffect(() => {
    if (!loading && textRef.current) {
      const isTextClamped = textRef.current.clientHeight >= 76;
      setIsClamped(isTextClamped);
    }
  }, [textRef, loading]);

  useEffect(() => {
    if (isMobileVersion && location?.state?.tab) {
      setPageBack(location);
    }
  }, []);

  const getIdFromPath = (path, key) => {
    const regex = new RegExp(`${key}/([^/]+)`);
    const match = path.match(regex);
    return match ? match[1] : null;
  };

  const handleBack = (e) => {
    e.preventDefault();

    const locPathname = location.pathname;
    const idJourney = getIdFromPath(locPathname, "journey");
    const idAcademy = getIdFromPath(locPathname, "academy");
    // const idCourse = getIdFromPath(locPathname, "course");
    // const idModule = getIdFromPath(locPathname, "module");

    if (pageBack?.state?.tab) {
      navigate(`/content-library`, {
        state: { tab: pageBack?.state?.tab || "" },
      });
    } else {
      navigate(`/content-library/academy/${idAcademy}/journey/${idJourney}`);
    }
  };

  return (
    <>
      <div style={wraperStyle}>
        <Flex style={{ display: "flex", flexDirection: "column" }}>
          <Row className="row-image me-0" style={rowImageStyle}>
            {loading ? (
              <Skeleton.Avatar
                active
                shape="square"
                style={{ width: "99vw", height: "160px" }}
              />
            ) : (
              // thumbnail
              <Image
                width={"100%"}
                height={160}
                style={{ objectFit: "cover", height: "100%" }}
                src={thumbnail}
                preview={false}
                fallback={defaultImage}
                alt="Course Thumbnail Content Library Mobile"
              />
            )}
            <div
              className="btn-back-mobile"
              style={{
                position: "absolute",
                top: "20px",
                left: "18px",
                cursor: "pointer",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: whiteColor,
                boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.18)",
              }}
              onClick={(e) => handleBack(e)}
            >
              <ArrowLeftOutlined
                style={{
                  color: colorTextTitleMobile,
                  width: "15px",
                  height: "15px",
                }}
              />
            </div>
          </Row>
          <div className="div-right" style={divRightStyle}>
            {loading ? (
              <Skeleton.Input
                active
                size={16}
                style={{ marginBottom: "10px", minWidth: "70px" }}
              />
            ) : (
              <p className="p-course" style={pProgramStyle}>
                {t("feature.feature_cl.main_collection_card.course_cap")}{" "}
                {index}
              </p>
            )}
            <Row>
              {loading ? (
                <Skeleton.Input
                  active
                  size={22}
                  style={{
                    marginRight: "8px",
                    minWidth: "300px",
                    marginBottom: "6px",
                  }}
                />
              ) : (
                <span
                  className="title-course-desc"
                  style={titleCourseDescStyle}
                >
                  {courseName}
                </span>
              )}
            </Row>
            <div ref={textRef}>
              {loading ? (
                <Skeleton
                  paragraph={{ rows: 10 }}
                  style={{ marginTop: "8px" }}
                  active
                />
              ) : (
                <div
                  className="text-description"
                  style={{
                    textAlign: "left",
                    lineHeight: "22px",
                    whiteSpace: "pre-wrap",
                    fontSize: "14px",
                    fontWeight: "400",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    marginTop: "12px",
                    color: colorTextDesc,
                  }}
                >
                  {description}
                </div>
              )}
            </div>
            {isClamped && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  justifyContent: "end",
                  color: ColorPrimary,
                  cursor: "pointer",
                  marginTop: "8px",
                  width: "fit-content",
                  alignSelf: "end",
                }}
                onClick={() => setOpenModalDetailCourse()}
              >
                {loading ? (
                  <Skeleton.Input
                    active
                    size={20}
                    style={{ minWidth: "80px" }}
                  />
                ) : (
                  <>
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {t("main.popup.more")}
                    </span>
                    <RightOutlined />
                  </>
                )}
              </div>
            )}
          </div>
          <div
            className="btn-collection"
            style={{
              position: "absolute",
              right: isMobileVersion ? 12 : 0,
              top: isMobileVersion ? "20px" : "0",
              display:
                flagBtnCollection !== undefined && flagBtnCollection !== null
                  ? "block"
                  : "none",
            }}
          >
            {loading ? (
              <Skeleton.Button
                active
                style={{
                  width: "140px",
                  height: "32px",
                  borderRadius: "6px",
                }}
              />
            ) : (
              <Button
                className={
                  isCollection
                    ? `btn-remove-collection-content-library ${
                        isMobileVersion ? "mobile" : ""
                      }`
                    : `btn-add-collection-content-library ${
                        isMobileVersion ? "mobile" : ""
                      }`
                }
                name={
                  isCollection
                    ? "btn-remove-program-collection-content-library"
                    : "btn-add-program-collection-content-library"
                }
                style={{
                  borderRadius: "6px",
                  padding: "6px 12px",
                  fontSize: "12px",
                  fontWeight: "500",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: "auto",
                  marginLeft: "0",
                  width: isMobileVersion ? "100%" : "177px",
                }}
                onClick={() => funcCollection(isCollection ? "remove" : "add")}
                loading={isCollectionLoading}
              >
                <div
                  style={
                    isMobileVersion
                      ? { marginTop: "-3px" }
                      : {
                          marginRight: "4px",
                        }
                  }
                  className={
                    isMobileVersion
                      ? "btn-collection-icon-mobile"
                      : "btn-collection-icon"
                  }
                >
                  <Image
                    preview={false}
                    src={
                      isCollection
                        ? ic_removecollection_contentlibrary
                        : ic_addcollection_contentlibrary
                    }
                    style={isMobileVersion && { width: "13px", height: "13px" }}
                  />
                </div>
                <span style={{ lineHeight: "normal" }}>
                  {isCollection
                    ? t(
                        "feature.feature_cl.main_collection_card.remove_from_collection",
                      )
                    : t(
                        "feature.feature_cl.collection_action.add_to_collection",
                      )}
                </span>
              </Button>
            )}
          </div>
        </Flex>
      </div>
    </>
  );
};

export default CourseDescriptionContentLibraryMobile;
